// Imports
import React from 'react';
import Feature from '..';
import feature from './feature';


// Function component
const Calendars: React.FC = () => <Feature {...feature} />;

export default Calendars;
